export default __webpack_public_path__ + "static/media/image10.8c439e6e.png";